import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

const BASE = "flex h-10 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base md:text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:opacity-50";

export const PasswordInput = React.forwardRef(({ className, wrapperClassName, ...props }, ref) => {
  const [show, setShow] = useState(false);
  const tid = props["data-testid"];
  return (
    <div className={cn("relative", wrapperClassName)}>
      <input ref={ref} {...props} type={show ? "text" : "password"} className={cn(BASE, className, "pr-10")} />
      <button type="button" tabIndex={-1} onClick={() => setShow((v) => !v)}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors"
        aria-label={show ? "Esconder senha" : "Mostrar senha"} data-testid={tid ? `${tid}-toggle` : undefined}>
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";
